const DEFAULT_AVATARID = '00000000-0000-0000-0000-000000000000';

export default (avatarId?: string, size?: number) => {
  const id = avatarId || DEFAULT_AVATARID;
  const h = size ? `?h=${size}` : '';
  return `/api/avatar/${id}${h}`;
};
